import { ComponentChildren, ComponentType, Fragment, h } from "preact"
import { WrapperProps } from "./types"
import type { InputSearchFilter } from "@nosto/nosto-js/client"

/**
 * @group Components
 */
export interface KeywordWrapperProps {
    wrapperComponent?: ComponentType<WrapperProps>
    filter?: InputSearchFilter
    children: ComponentChildren
}

/**
 * @group Components
 */
export function KeywordWrapper({ children, filter, wrapperComponent: Wrapper }: KeywordWrapperProps) {
    return Wrapper ? <Wrapper keywordComponent={children} filter={filter} /> : <Fragment>{children}</Fragment>
}
